import { useDictionaryContext } from 'application/contexts/DictionaryContext';
import { useSiteContext } from 'application/contexts/SiteContext';
import { getNewsLetterForm } from 'application/repositories/newsletterSignUpFormRepository';
import { CreateSubscriberProps, NewsLetterSignUp } from 'designsystem/components/3-organisms/SignUp';
import { axiosInstance as axios } from 'helpers/axiosInstance';
import { useEffect, useState } from 'react';

export const NewsletterSignupFeature: React.FC<Content.NewsletterSignup> = ({ content }) => {
	const dictionary = useDictionaryContext();
	const siteContext = useSiteContext();

	const [signupForm, setSignupForm] = useState<Models.NewsLetterSignUpFormResponse>(null);
	const fetchingData = signupForm === null;
	const formFields = signupForm?.inputFields;
	const networkError = signupForm?.resultFromDefinitionResponse?.success === false;

	const { signupIdOverride } = content?.properties ?? {};
	const signupIdOverrideExists = signupIdOverride && signupIdOverride !== '';

	const newsletterFormId = signupIdOverrideExists ? signupIdOverride : siteContext.theme;

	useEffect(() => {
		(async () => {
			const signupFormData = await getNewsLetterForm(newsletterFormId);
			setSignupForm(signupFormData);
		})();
	}, [newsletterFormId]);

	const signUpHandler = (params: CreateSubscriberProps) =>
		axios(`/engagement-api/v1/apsis/subscriber/CreateSubscriber`, {
			params,
			// TODO: Update Axios so we can use paramsSerializer: { indexes:null } instead
			paramsSerializer(params) {
				const paramstring = `organisationName=${encodeURIComponent(params.organisationName)}${Object.keys(params.inputs)
					?.map((key) => {
						if (key.includes('Demographicfield')) {
							const demoIndexfield = !isNaN(Number(key.slice(-1))) ? `&demographicIndex=${key.slice(-1)}` : '';
							return `&${key.slice(0, -1)}=${encodeURIComponent(params.inputs[key])}${demoIndexfield}`;
						}
						if (Array.isArray(params.inputs[key])) {
							return `&${params.inputs[key].map((id: number) => `${key}=${encodeURIComponent(id)}`).join('&')}`;
						}
						return `&${key}=${encodeURIComponent(params.inputs[key])}`;
					})
					.join('')}`;
				return paramstring;
			},
		});

	return (
		<>
			{fetchingData ? <p>{dictionary.getServiceInfo('FetchingData')}.</p> : null}
			{networkError ? <p>{dictionary.getNewsletter('ApiError')}</p> : null}
			{!fetchingData && !networkError ? (
				<NewsLetterSignUp
					formFields={formFields}
					organisationName={signupForm.organisationName}
					noNewslettersSelectedError={dictionary.getNewsletter('NoNewsletterSelected')}
					signUpHandler={signUpHandler}
					submitText={dictionary.getNewsletter('Subscribe')}
					apiErrorText={dictionary.getNewsletter('ApiError')}
					successText={dictionary.getNewsletter('SignupSuccess')}
				/>
			) : null}
		</>
	);
};
